import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
// @ts-ignore
import { AfyPlanBenefitsInfo, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useGetSteps } from "../../utils/getSteps";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
import showToast from "../../services/toast";
import { HeaderTitlePage } from "../../components/resources/headerTitlePage/headerTitlePage";
import { useSummaryFilters } from "../addBusiness/hooks";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
import { useDataPerson, useGetPaymentMode, useGetPerson, usePaymentModeData, usePremiumCalculate, } from "./hooks";
import { useGetCatalogGender } from "./hooks/callApis/callApiCatalogGender";
import { usePlanData } from "./hooks/usePlanData";
import { useLocation } from "react-router-dom";
import { useGetInformationSteps } from "ah_utility/workflow";
import useCompleteStepCalculatePremium from "./hooks/useCompleteStep";
export var CalculatePremium = function () {
    var _a, _b;
    var steps = useGetSteps();
    var _c = useState(""), paymentMode = _c[0], setPaymentMode = _c[1];
    var _d = useState("0"), annualPremium = _d[0], setAnnualPremium = _d[1];
    var _e = useState(0), coverageAmount = _e[0], setCoverageAmount = _e[1];
    var filters = useSummaryFilters().filters;
    var pathname = useLocation().pathname;
    var pathLocation = "/" + pathname.split("/")[1];
    var Plan = React.useState(findParamInLocalStorage("Plan"))[0];
    var planData = Plan === null || Plan === void 0 ? void 0 : Plan["0"];
    var planName = (_a = planData === null || planData === void 0 ? void 0 : planData.name) !== null && _a !== void 0 ? _a : "";
    var projectId = React.useState(findParamInLocalStorage("projectId"))[0];
    var personData = React.useState(findParamInLocalStorage("personData"))[0];
    var _f = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _f[0], setSeeToast = _f[1];
    // CALL APIS
    var _g = useGetPaymentMode(true, projectId), responsePaymentMode = _g.responsePaymentMode, loadingPaymentMode = _g.loadingPaymentMode;
    var _h = useGetPerson(true, personData), responsePerson = _h.responsePerson, loadingPerson = _h.loadingPerson, errorPerson = _h.errorPerson;
    var _j = useGetCatalogGender(true), responseGetCatalog = _j.responseGetCatalog, loadingGetCatalog = _j.loadingGetCatalog, errorGetCatalog = _j.errorGetCatalog;
    //END CALL APIS
    var _k = useDataPerson(responsePerson, responseGetCatalog), birthDate = _k.birthDate, gender = _k.gender, creditCardList = _k.creditCardList;
    var _l = usePlanData(), productCode = _l.productCode, planCode = _l.planCode;
    var _m = usePremiumCalculate(productCode, planCode, birthDate, gender), responseCalculate = _m.responseCalculate, errorCalculate = _m.errorCalculate, loadingCalculate = _m.loadingCalculate, calculatePremium = _m.calculatePremium;
    var _o = useGetInformationSteps(pathLocation), instanceId = _o.instanceId, workFlowId = _o.workFlowId, currentStep = _o.currentStep, nextStep = _o.nextStep;
    var dataCalculation = {
        gender: gender,
        smokes: false,
        coverageAmount: coverageAmount,
        paymentMode: paymentMode,
        planCode: planCode,
    };
    var _p = useCompleteStepCalculatePremium(instanceId, workFlowId, currentStep, nextStep, setSeeToast, dataCalculation), onClickNextStep = _p.onClickNext, handleClickPrevious = _p.handleClickPrevious, loadingComplete = _p.loadingComplete;
    var coverages = ((_b = planData === null || planData === void 0 ? void 0 : planData.benefits) !== null && _b !== void 0 ? _b : []).map(function (benefit) { return ({
        id: benefit.id,
        name: benefit.description,
        value: benefit.value,
    }); });
    var listModalidadPago = usePaymentModeData(responsePaymentMode).listModalidadPago;
    useEffect(function () {
        if ((responseCalculate === null || responseCalculate === void 0 ? void 0 : responseCalculate.annualPremium) !== undefined) {
            setAnnualPremium(String(responseCalculate.annualPremium));
        }
    }, [responseCalculate]);
    var listTipoCuenta = useState([
        { id: "1", name: "Tarjetas", value: "TARJETAS" },
    ])[0];
    var handleChangeTipoCuenta = function (data) {
        console.log("onChangeTipoCuenta", data);
    };
    var handleChangeTerminalTarjeta = function (data) {
        var _a;
        var coverage = (_a = data.montoAprobado) !== null && _a !== void 0 ? _a : "";
        var mode = data.modalidadPago;
        setPaymentMode(mode);
        setCoverageAmount(Number(coverage));
        calculatePremium(coverage, mode);
    };
    return (_jsxs(React.Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loadingPaymentMode ||
                    loadingPerson ||
                    loadingGetCatalog ||
                    loadingCalculate ||
                    loadingComplete, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: "Calculando..." }), _jsx(HeaderTitlePage, { titlePage: "Calcular prima", breadCrumbs: [], steps: steps }), _jsx(AfyPlanBenefitsInfo, { annualPremium: annualPremium, coverages: coverages, listModalidadPago: listModalidadPago, listTerminalTarjeta: creditCardList, listTipoCuenta: listTipoCuenta, planName: planName, onClickNext: function () { return onClickNextStep(); }, onChangeTipoCuenta: handleChangeTipoCuenta, onChangeTerminalTarjeta: handleChangeTerminalTarjeta, filters: filters, minHeight: "calc(100vh - 155px)" })] }));
};
